import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleUserData, loginSuccess } from "../auth/authSlice";
import { reactLocalStorage } from "reactjs-localstorage";
import { GetUserRoleThunk } from "../features/EventOrganiser/redux/eventOrganiserThunks";
import { loginUserThunk, forceLogoutAllThunk } from "../auth/authThunk";
import userStore from "../zustand/userStore";
import LoaderOverlay from "./LoaderOverlay";
import { setAppdAiGuest, setAppdAiUser } from "../utils/appdAiHelpers";
import { getBotAccessList } from "../features/student/redux/studentThunk";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading } = useSelector((state) => state.authSlice);
  const { botAccess } = useSelector((state) => state.student);

  const setUser = userStore.getState().setUser;

  useEffect(() => {
    // setAppdAiGuest("login");
    dispatch(getBotAccessList());
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const resultAction = await dispatch(
        loginUserThunk({ username, password })
      );
      if (loginUserThunk.fulfilled.match(resultAction)) {
        if (resultAction.payload.message === "VERIFICATION_PENDING") {
          alert(
            "Your account is not verified. Please verify your account before logging in.",
          );
          let emailvalue = "";
          let mobilevalue = "";
          if (!resultAction.payload.verification.email_verified) {
            emailvalue = resultAction.payload.user.email;
          }
          if (!resultAction.payload.verification.mobile_verified) {
            mobilevalue = resultAction.payload.user.contact_number;
          }
          const payload = {
            email: emailvalue || "",
            contact_number: mobilevalue || "",
          }; // Replace with actual user data

          const notificationPayload = {
            email: resultAction.payload.user.email || "",
            contact_number: resultAction.payload.user.contact_number || "",
            account_type: resultAction.payload.user.account_type || "",
            // adminName: resultAction.payload.user.username || "",
          };

          navigate("/otp", {
            state: {
              formData: payload,
              source: "login",
              notificationPayload,
              isWhatsapp: botAccess?.isWhatsapp,
              isEmailSuccessful: botAccess?.isEmailSuccessful,
              isSMS: botAccess?.isSMS,
            },
          });
          return;
        }
        const user = resultAction.payload;
        setUser(user.user);
        dispatch(handleUserData(user.user));
        setAppdAiUser(user.user, "general");
        navigate("/dashboard");
      } else {
        if (resultAction.payload === "LIMIT_REACHED") {
          setShowLimitPopup(true);
        } else {
          alert(resultAction.payload || "Login failed");
        }
      }
    } catch (error) {
      alert("Something went wrong");
    }
  };

  const handleForceLogout = async () => {
    const result = await dispatch(forceLogoutAllThunk({ username, password }));
    //alert("All other devices logged out. You can now login normally.");
    if (forceLogoutAllThunk.fulfilled.match(result)) {
      setShowLimitPopup(false);
      alert("All other devices logged out. You can now login normally.");
      // Optional: Automatically trigger handleLogin again here
    } else {
      alert("Force logout failed: " + result.payload);
    }
  };

  const styles = {
    pageContainer: {
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      background:
        "linear-gradient(135deg, #e8e0f0 0%, #f5f0fa 25%, #fdf5f5 50%, #fef6e8 75%, #f8f4fc 100%)",
      padding: "30px 20px 20px",
    },
    card: {
      background: "#ffffff",
      borderRadius: "20px",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
      padding: "50px 40px",
      width: "100%",
      maxWidth: "420px",
    },
    title: {
      fontSize: "32px",
      fontWeight: "700",
      color: "#1a1a2e",
      textAlign: "center",
      marginBottom: "8px",
    },
    subtitle: {
      fontSize: "14px",
      color: "#6b7280",
      textAlign: "center",
      marginBottom: "35px",
    },
    label: {
      fontSize: "13px",
      fontWeight: "600",
      color: "#374151",
      marginBottom: "8px",
      display: "block",
    },
    inputContainer: {
      position: "relative",
      marginBottom: "20px",
    },
    input: {
      width: "100%",
      padding: "14px 45px 14px 16px",
      border: "1px solid #e5e7eb",
      borderRadius: "10px",
      fontSize: "14px",
      color: "#374151",
      transition: "all 0.3s ease",
      outline: "none",
      boxSizing: "border-box",
    },
    inputIcon: {
      position: "absolute",
      left: "16px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#9ca3af",
      fontSize: "16px",
      width: "20px",
      textAlign: "center",
      pointerEvents: "none",
    },
    eyeIcon: {
      position: "absolute",
      right: "16px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#9ca3af",
      fontSize: "16px",
      cursor: "pointer",
    },
    linksContainer: {
      textAlign: "center",
      marginBottom: "25px",
    },
    linkText: {
      fontSize: "13px",
      color: "#6b7280",
    },
    link: {
      color: "#8b5cf6",
      cursor: "pointer",
      fontWeight: "500",
      textDecoration: "none",
    },
    forgotLink: {
      display: "block",
      marginTop: "8px",
      color: "#8b5cf6",
      cursor: "pointer",
      fontWeight: "500",
      fontSize: "13px",
      textDecoration: "none",
    },
    button: {
      width: "100%",
      padding: "14px",
      border: "none",
      borderRadius: "10px",
      background:
        "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
      color: "#ffffff",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
    },
  };

  return (
    <>
      <style>{`
        .login-input:focus {
          border-color: #8b5cf6 !important;
          box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1) !important;
        }
        
        .login-input::placeholder {
          color: #9ca3af;
        }
        
        .login-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;
        }
        
        .login-link:hover {
          text-decoration: underline !important;
        }

        @media (max-width: 480px) {
          .login-card {
            padding: 30px 25px !important;
            margin: 15px !important;
          }
          
          .login-title {
            font-size: 26px !important;
          }
        }
      `}</style>

      {loading && <LoaderOverlay />}
      <div style={styles.pageContainer}>
        <div className="login-card" style={styles.card}>
          <h1 className="login-title" style={styles.title}>
            Welcome Back!
          </h1>
          <p style={styles.subtitle}>Sign in to continue</p>

          <form onSubmit={handleLogin}>
            <div>
              {/* <label style={styles.label}>Email Address</label> */}
              <label style={styles.label}>Enter Email/Contact Number</label>
              <div style={styles.inputContainer}>
                <input
                  type="text"
                  className="login-input"
                  style={styles.input}
                  placeholder="Enter your email"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            </div>

            <div>
              <label style={styles.label}>Password</label>
              <div style={styles.inputContainer}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="login-input"
                  style={styles.input}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <i
                  className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  style={styles.eyeIcon}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "6px",
                marginBottom: "25px",
              }}
            >
              <span
                className="login-link"
                style={styles.forgotLink}
                onClick={() =>
                  navigate("/forgot-password", { state: { type: "forgot" } })
                }
              >
                Forgot Password
              </span>

              <span style={{ margin: "0 2px" }}>/</span>

              <span
                className="login-link"
                style={styles.forgotLink}
                onClick={() =>
                  navigate("/forgot-password", { state: { type: "set" } })
                }
              >
                Set Password
              </span>
              <span style={{ margin: "0 2px" }}>|</span>
              <span
                className="login-link"
                style={styles.forgotLink}
                onClick={() =>
                  navigate("/signup", {
                    state: { register_type: "login_page" },
                  })
                }
              >
                signup
              </span>
            </div>

            <button
              type="submit"
              className="login-button"
              style={styles.button}
            >
              Login
            </button>
          </form>
        </div>
      </div>
      {showLimitPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)", // Dim background
            backdropFilter: "blur(6px)", // Blur effect
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            padding: "20px",
          }}
        >
          <div
            className="login-card"
            style={{
              ...styles.card,
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              boxSizing: "border-box",
            }}
          >
            {/* Icon */}
            <div
              style={{
                fontSize: "50px",
                color: "#f59e0b",
                marginBottom: "20px",
              }}
            >
              <i className="fas fa-exclamation-triangle"></i>
            </div>

            {/* Title & Subtitle */}
            <h2 style={styles.title}>Device Limit Reached</h2>
            <p style={{ ...styles.subtitle, marginBottom: "30px" }}>
              You are currently signed in on <b>2 other devices</b>. Would you
              like to sign out from all sessions to continue here?
            </p>

            {/* Buttons */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <button
                className="login-button"
                style={{ ...styles.button, margin: "0" }}
                onClick={handleForceLogout}
                disabled={loading}
              >
                {loading ? "Processing..." : "Yes, Sign Out Others"}
              </button>

              <button
                className="login-link"
                style={{
                  ...styles.link,
                  background: "none",
                  border: "none",
                  padding: "10px",
                  fontSize: "14px",
                  color: "#6b7280",
                }}
                onClick={() => setShowLimitPopup(false)}
              >
                Cancel and go back
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
